import React from 'react';
import Slide from 'react-reveal/Slide';
import { useUnit } from 'effector-react';
import { chipFactory } from 'src/models/app';
import { useT } from 'src/i18n';

import './Form.scss';

const { view: $telegram, api: telegramApi } = chipFactory();
const { view: $email, api: emailApi } = chipFactory();

export const Form = () => {
  const t = useT();

  return (
    <>
      <h1 className="heading heading_form">
        {t.contact.heading}
      </h1>
      <div className="form-block">
        <Slide left>
          <Contacts t={t} />
        </Slide>

        <Slide right>
          <Socials t={t} />
        </Slide>
      </div>
    </>
  );
};

const Contacts = ({ t }) => (
  <div className="form-block__contacts">
    <ContactLink
      label={t.contact.labels.telegram}
      value={t.contacts.telegramHandle}
      href={t.contacts.telegramUrl}
      external
    />
    <ContactLink
      label={t.contact.labels.email}
      value={t.contacts.email}
      href={`mailto:${t.contacts.email}`}
    />
    <ContactLink
      label={t.contact.labels.phone}
      value={t.contacts.phoneDisplay}
      href={t.contacts.phoneHref}
    />
  </div>
);

const ContactLink = ({
  label, value, href, external,
}) => (
  <a
    className="form-block__contact"
    href={href}
    target={external ? '_blank' : undefined}
    rel={external ? 'noreferrer' : undefined}
  >
    <span className="form-block__contact-label">{label}</span>
    <span className="form-block__contact-value">{value}</span>
  </a>
);

const Socials = ({ t }) => (
  <div className="form-block__socials">
    {t.contact.noteStart}
    <TelegramChip label={t.contact.chipTelegram} url={t.contacts.telegramUrl} />
    <br />
    {t.contact.noteMiddle}
    <EmailChip label={t.contact.chipEmail} email={t.contacts.email} />
  </div>
);

const setView = (view, viewApi) => () => {
  if (view) {
    viewApi.setVisible();
  } else {
    viewApi.setNotVisible();
  }
};

const TelegramChip = ({ label, url }) => {
  const view = useUnit($telegram);

  const classTelegram = `chip__icon icon_telegram  ${view ? 'icon_animation' : ''}`;

  return (
    <div
      className={`chip ${view ? 'chip_padding' : ''}`}
      onMouseEnter={setView(true, telegramApi)}
      onMouseLeave={setView(false, telegramApi)}
      onClick={() => window.open(url, '_blank')}
    >
      <img
        src="/images/Telegram.png"
        className={classTelegram}
        alt=""
      />
      {label}
    </div>
  );
};

const EmailChip = ({ label, email }) => {
  const view = useUnit($email);

  const classEmail = `chip__icon icon_email ${view ? 'icon_animation' : ''}`;

  return (
    <div
      className={`chip ${view ? 'chip_padding' : ''}`}
      onMouseEnter={setView(true, emailApi)}
      onMouseLeave={setView(false, emailApi)}
      onClick={() => { window.location.href = `mailto:${email}`; }}
    >
      <div className={classEmail}>
        <img
          src="/images/Email.png"
          alt=""
        />
      </div>

      {label}
    </div>
  );
};
